import FormContainer from "../../../common/forms/FormContainer";
import FormField from "../../../common/forms/FormField";
import styled from "styled-components";
import SimpleLabelField from "../../../common/forms/SimpleLabelField";

const StyledPage = styled.div`
    & {
        width: 100%;
    }
`;

export default function OtherInfoSection({ productData, pageEnabled }) {
    return (
        <StyledPage>
            <FormContainer className={`${pageEnabled ? "enabled-form" : "disabled-form"}`} title="OTHER INFO">
                <div style={{ display: "flex", flexDirection: "column", gap: "16px", width: "100%" }}>
                    {/* Top Row */}
                    <div style={{ display: "flex", flexDirection: "row", gap: "16px", width: "100%" }}>
                        {/* Left side: Description */}
                        <div style={{ flex: 2 }}>
                            <SimpleLabelField
                                className="hover-not-allowed"
                                title="Description"
                                varName="description"
                                value={productData?.description}
                                assistiveTextColorOverride="var(--text-icons-gray-300)"
                                formFieldColumSize={1}
                                styling={{ formFieldHeight: "185px" }}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Description"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                        </div>
                        {/* Right side: Title, Type/Gender, Category */}
                        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "16px" }}>
                            <FormField
                                type="text"
                                title="Description title"
                                value={productData?.descriptionTitle}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Description title"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                            <div style={{ display: "flex", flexDirection: "row", gap: "16px" }}>
                                <div style={{ flex: 1 }}>
                                    <FormField
                                        type="text"
                                        title="Type"
                                        value={productData?.itemType}
                                        requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                        tooltip="Type"
                                        placeholder={pageEnabled ? "Not provided by the brand" : ""}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <FormField
                                        type="text"
                                        title="Gender"
                                        value={productData?.gender}
                                        requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                        tooltip="Gender"
                                        placeholder={pageEnabled ? "Not provided by the brand" : ""}
                                    />
                                </div>
                            </div>
                            <FormField
                                type="text"
                                title="Category"
                                value={productData?.category}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Category"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                        </div>
                    </div>

                    {/* Middle Row */}
                    <div style={{ display: "flex", flexDirection: "row", gap: "16px", width: "100%" }}>
                        <div style={{ flex: 1 }}>
                            <SimpleLabelField
                                className="hover-not-allowed"
                                title="Short description"
                                value={productData?.shortDescription}
                                styling={{ formFieldHeight: "118px" }}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Short description"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <SimpleLabelField
                                className="hover-not-allowed"
                                title="Composition"
                                value={productData?.composition}
                                styling={{ formFieldHeight: "118px" }}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Composition"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <SimpleLabelField
                                className="hover-not-allowed"
                                title="Wash"
                                value={productData?.washAndCare}
                                styling={{ formFieldHeight: "118px" }}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Wash"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <SimpleLabelField
                                className="hover-not-allowed"
                                title="Maintenance"
                                value={productData?.maintenance}
                                styling={{ formFieldHeight: "118px" }}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Maintenance"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                        </div>
                    </div>

                    {/* Bottom Row */}
                    <div style={{ display: "flex", flexDirection: "row", gap: "16px", width: "100%" }}>
                        <div style={{ flex: 1 }}>
                            <FormField
                                type="text"
                                title="Country of origin"
                                value={productData?.countryOfOrigin}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Country of origin"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <FormField
                                type="text"
                                title="Customs tariff code"
                                value={productData?.customsTariffCode}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Customs tariff code"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <FormField
                                type="text"
                                title="Customs tariff text"
                                value={productData?.customsTariffText}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Customs tariff text"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <FormField
                                type="text"
                                title="Dimensions"
                                value={productData?.dimensions}
                                requiredType={pageEnabled ? "disabledSimple" : "locked"}
                                tooltip="Dimensions"
                                placeholder={pageEnabled ? "Not provided by the brand" : ""}
                            />
                        </div>
                    </div>
                </div>
            </FormContainer>
        </StyledPage>
    );
}
